import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "down_arr",
  "use": "down_arr-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"down_arr\"><path d=\"M34.06 18.44a1.5 1.5 0 0 1 0 2.12L24 30.622l-10.06-10.06a1.5 1.5 0 0 1 2.12-2.122L24 26.38l7.94-7.94a1.5 1.5 0 0 1 2.12 0Z\" fill=\"#3B3F3D\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol